export default __webpack_public_path__ + "static/media/confirmation3.28916b24.jpg";